import classNames from 'classnames';
import React, { FC } from 'react';
type OwnProps = {
    className?: any;
    fillColor?: any;
    pathStrokeColor?: any;
    pathFillColor?: any;
};
type SVGChecklistProps = OwnProps;

const SVGChecklist: FC<SVGChecklistProps> = (props) => {
    const { fillColor, pathStrokeColor, pathFillColor, className } = props;
    return (
        <svg
            width="41"
            height="51"
            viewBox="0 0 41 51"
            fill={fillColor ?? 'none'}
            xmlns="http://www.w3.org/2000/svg"
            className={classNames(className)}
        >
            <path
                d="M35.4346 6.68196H30.8207V4.61786C30.8207 3.95005 30.0922 3.64653 29.4244 3.64653H25.8426C24.9927 1.21814 22.8678 0.00394611 20.4394 0.00394611C18.0378 -0.0863428 15.8533 1.38628 15.0363 3.64653H11.5151C10.8473 3.64653 10.1795 3.95005 10.1795 4.61786V6.68196H5.56546C2.83123 6.71112 0.59434 8.86806 0.46582 11.5994V46.386C0.46582 49.0572 2.89421 50.9999 5.56546 50.9999H35.4346C38.1059 50.9999 40.5342 49.0572 40.5342 46.386V11.5995C40.4057 8.86806 38.1688 6.71112 35.4346 6.68196ZM12.6078 6.07492H15.9468C16.5297 6.0038 16.9979 5.56038 17.1004 4.98215C17.4599 3.41645 18.8335 2.29254 20.4394 2.25025C22.0305 2.29847 23.3834 3.42586 23.7177 4.98215C23.8266 5.58036 24.3257 6.02948 24.9319 6.07492H28.3924V10.9317H12.6078V6.07492ZM38.1059 46.3861C38.1059 47.7217 36.7702 48.5716 35.4346 48.5716H5.56546C4.22983 48.5716 2.89421 47.7217 2.89421 46.3861V11.5995C3.01808 10.2093 4.16987 9.13591 5.56546 9.11046H10.1794V12.2067C10.2435 12.8869 10.8327 13.3958 11.515 13.3602H29.4243C30.1192 13.3982 30.7268 12.8963 30.8206 12.2067V9.11035H35.4345C36.83 9.13591 37.9819 10.2092 38.1057 11.5994V46.3861H38.1059Z"
                stroke={pathStrokeColor}
                fill={pathFillColor ?? 'white'}
            />
            <path
                d="M15.8255 27.1412C15.3701 26.6612 14.6141 26.6341 14.1255 27.0805L10.2401 30.7838L8.60096 29.0838C8.14556 28.6038 7.38955 28.5769 6.90104 29.0232C6.43077 29.5159 6.43077 30.2911 6.90104 30.7838L9.39009 33.3336C9.60552 33.5748 9.91671 33.7082 10.24 33.6979C10.5602 33.6933 10.8657 33.5624 11.0899 33.3336L15.8252 28.8411C16.2947 28.4105 16.3261 27.6807 15.8953 27.2114C15.8732 27.1869 15.8499 27.1635 15.8255 27.1412Z"
                stroke={pathStrokeColor}
                fill={pathFillColor ?? 'white'}
            />
            <path
                d="M33.2492 29.7516H19.286C18.6154 29.7516 18.0718 30.2952 18.0718 30.9658C18.0718 31.6364 18.6154 32.18 19.286 32.18H33.2492C33.9198 32.18 34.4634 31.6364 34.4634 30.9658C34.4634 30.2952 33.9198 29.7516 33.2492 29.7516Z"
                stroke={pathStrokeColor}
                fill={pathFillColor ?? 'white'}
            />
            <path
                d="M15.8255 17.4276C15.3701 16.9476 14.6141 16.9205 14.1255 17.367L10.2401 21.0702L8.60096 19.3703C8.14556 18.8903 7.38955 18.8632 6.90104 19.3096C6.43077 19.8023 6.43077 20.5775 6.90104 21.0702L9.39009 23.62C9.60552 23.8613 9.91671 23.9947 10.24 23.9843C10.5602 23.9798 10.8657 23.8488 11.0899 23.62L15.8252 19.1275C16.2947 18.6969 16.3261 17.9671 15.8953 17.4978C15.8732 17.4733 15.8499 17.4499 15.8255 17.4276Z"
                stroke={pathStrokeColor}
                fill={pathFillColor ?? 'white'}
            />
            <path
                d="M33.2492 20.0381H19.286C18.6154 20.0381 18.0718 20.5817 18.0718 21.2523C18.0718 21.9229 18.6154 22.4665 19.286 22.4665H33.2492C33.9198 22.4665 34.4634 21.9229 34.4634 21.2523C34.4634 20.5817 33.9198 20.0381 33.2492 20.0381Z"
                stroke={pathStrokeColor}
                fill={pathFillColor ?? 'white'}
            />
            <path
                d="M15.8255 36.8546C15.3701 36.3746 14.6141 36.3476 14.1255 36.794L10.2401 40.4972L8.60096 38.7973C8.14556 38.3172 7.38955 38.2903 6.90104 38.7366C6.43077 39.2293 6.43077 40.0045 6.90104 40.4972L9.39009 43.047C9.60552 43.2883 9.91671 43.4217 10.24 43.4113C10.5602 43.4068 10.8657 43.2758 11.0899 43.047L15.8252 38.5545C16.2947 38.1239 16.3261 37.3941 15.8953 36.9248C15.8732 36.9004 15.8499 36.877 15.8255 36.8546Z"
                stroke={pathStrokeColor}
                fill={pathFillColor ?? 'white'}
            />
            <path
                d="M33.2492 39.4652H19.286C18.6154 39.4652 18.0718 40.0088 18.0718 40.6794C18.0718 41.35 18.6154 41.8936 19.286 41.8936H33.2492C33.9198 41.8936 34.4634 41.35 34.4634 40.6794C34.4634 40.0088 33.9198 39.4652 33.2492 39.4652Z"
                stroke={pathStrokeColor}
                fill={pathFillColor ?? 'white'}
            />
        </svg>
    );
};

export default SVGChecklist;
